import {defaultPagination} from '#/notes/components/definitions'

export function formatPagination (pagination, pageSize = defaultPagination.pageSize) {
  return {
    total: pagination.count,
    currentPage: pagination.page,
    nextPage: pagination.pages > pagination.page ? pagination.page + 1 : null,
    pageSize: pageSize,
    previousPage: pagination.page > 1 ? pagination.page - 1 : null
  }
}
